import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMediaQuery } from 'react-responsive';
import { MEDIA_SM } from '../../../../../../define/media_queries';
import { propFunc, propStr, propShape, } from '../../../../../../helpers/custom-prop-types';
import SlideSearchSearchForm from '../../../../../Ui/SlideSearch/Form/SlideSearchSearchForm';
/**
 * マイページでProfiit Searchの検索フォームを表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchKeyword = (props) => {
    const { defaultValue, inputRef, onSubmit } = props;
    const isSm = useMediaQuery(MEDIA_SM);
    return (_jsx("div", Object.assign({ className: 'professional_mypage_top_proffit_search_keyword' }, { children: _jsx(SlideSearchSearchForm, { className: 'keyword_form', defaultValue: defaultValue, inputRef: inputRef, onSubmit: onSubmit, placeholder: isSm
                ? 'キーワードを入力してください'
                : '探しているスライドのキーワードを入力してください', titleComponent: _jsx("div", Object.assign({ className: 'form_title' }, { children: "\u30B9\u30E9\u30A4\u30C9\u3092\u63A2\u3059" })) }) })));
};
ProfessionalMyPageTopProffitSearchKeyword.propTypes = {
    defaultValue: propStr().isRequired,
    inputRef: propShape().isRequired,
    onSubmit: propFunc().isRequired,
};
export default ProfessionalMyPageTopProffitSearchKeyword;
